
import React, { FC, useState, useEffect } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import * as a from '../'

type Props = {
}

export const TBody: React.FC<Props> = ({ children }) => {

    return (
        <tbody>
            {children}
        </tbody>
    )
}